import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "form-dialog__title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "审核操作")
], -1)
const _hoisted_2 = {
  class: "form-dialog__content",
  style: {"display":"block"}
}

import { ref } from 'vue';
import {
  BaseForm,
  BaseFormItem,
  BaseRadioGroup,
  BaseRadio,
  BaseInput
} from 'xrk-components';
import { DetailType, InvoiceFunction } from '@V/invoice/src/types';
import { INVOICE_AUDIT_TYPE } from '@V/invoice/src/constants';
import { AuditInvoiceParams } from '@V/invoice/src/data-source/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-detail-dialog-audit',
  props: /*#__PURE__*/_mergeModels({
    detailType: {},
    invoiceFunction: { default: 1 }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose }) {

const props = __props;

const disabled = props.detailType !== 10;
const formRef = ref(null);
const formData = _useModel<AuditInvoiceParams>(__props, "modelValue");
const formRules = {
  invoiceStatus: [
    {
      required: true,
      trigger: 'change',
      message: '请选择审核结果'
    }
  ],
  noPassReason: [
    {
      required: true,
      trigger: 'change',
      message: '请填写驳回原因'
    }
  ]
};

const onRadioChange = v => {
  if (v) {
    formData.value.noPassReason = '';
  }
};

__expose({
  validate: (...args: any) => formRef.value?.validate(...args)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseForm), {
    ref_key: "formRef",
    ref: formRef,
    "label-position": "top",
    scrollToError: "",
    disabled: disabled,
    model: formData.value,
    rules: formRules
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(BaseFormItem), {
          label: "审核",
          prop: "invoiceStatus"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseRadioGroup), {
              modelValue: formData.value.invoiceStatus,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.invoiceStatus) = $event)),
              onChange: onRadioChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_unref(INVOICE_AUDIT_TYPE)), (item) => {
                  return (_openBlock(), _createBlock(_unref(BaseRadio), {
                    key: item.value,
                    value: item.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.invoiceFunction === 1 ? '蓝字' : '红字') + _toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (formData.value.invoiceStatus === 0)
          ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
              key: 0,
              label: "驳回原因",
              prop: "noPassReason"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  class: "form-dialog__w280",
                  type: "textarea",
                  placeholder: "请输入",
                  "show-word-limit": "",
                  rows: 4,
                  maxlength: 120,
                  modelValue: formData.value.noPassReason,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.noPassReason) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})